import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'
import { getToken } from '@/utils/auth'

// 修复 whiteList 未定义
const whiteList = ['/login', '/auth-redirect']

Vue.use(VueRouter)

// 配置 NProgress
NProgress.configure({ 
  showSpinner: false,
  easing: 'ease',
  speed: 500
})

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/Login.vue'),
    hidden: true
  },
  {
    path: '/403',
    component: () => import('@/views/error/403.vue'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error/404.vue'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/Index.vue'),
        name: 'Dashboard',
        meta: { title: 'menu.dashboard', icon: 'el-icon-data-board', requiresAuth: true }
      }
    ]
  },
  {
    path: '/proxy',
    component: () => import('@/layout/index.vue'),
    redirect: '/proxy/static',
    meta: { title: 'menu.proxy', icon: 'el-icon-connection' },
    children: [
      {
        path: 'static',
        component: () => import('@/views/proxy/static/Index.vue'),
        name: 'StaticProxy',
        meta: { title: 'menu.staticproxy', requiresAuth: true }
      }
    ]
  },
  {
    path: '/billing',
    component: () => import('@/layout/index.vue'),
    redirect: '/billing/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/billing/Index.vue'),
        name: 'Billing',
        meta: { title: 'menu.billing', icon: 'el-icon-money', requiresAuth: true }
      }
    ]
  },
  {
    path: '/users',
    component: () => import('@/layout/index.vue'),
    redirect: '/users/list',
    meta: { title: 'menu.users', icon: 'el-icon-user' },
    children: [
      {
        path: 'list',
        component: () => import('@/views/user/Index.vue'),
        name: 'Users',
        meta: { title: 'menu.users', requiresAuth: true }
      }
    ]
  },
  {
    path: '/account',
    component: () => import('@/layout/index.vue'),
    redirect: '/account/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/account/Index.vue'),
        name: 'Account',
        meta: { title: 'menu.account', icon: 'el-icon-user', requiresAuth: true }
      }
    ]
  },
  {
    path: '/reseller-management',
    component: () => import('@/layout/index.vue'),
    redirect: '/reseller-management/list',
    meta: { 
      title: 'menu.resellerManagement', 
      icon: 'el-icon-s-custom',
      requiresSuper: true,
      requiresAuth: true
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/reseller-management/List.vue'),
        name: 'ResellerList',
        meta: { 
          title: 'menu.resellerList', 
          requiresSuper: true,
          requiresAuth: true 
        }
      },
      {
        path: 'analytics',
        component: () => import('@/views/reseller-management/Analytics.vue'),
        name: 'ResellerAnalytics',
        meta: { 
          title: 'menu.resellerAnalytics', 
          requiresSuper: true,
          requiresAuth: true 
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const createRouter = () => new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// 权限检查函数
function hasPermission(userInfo, route) {
  if (route.meta && route.meta.requiresSuper) {
    return userInfo && userInfo.isSuper === 1
  } else {
    return true
  }
}

// 全局前置守卫
router.beforeEach(async(to, from, next) => {
  NProgress.start()
  
  const hasToken = getToken()
  
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      const hasUserInfo = store.getters['user/userInfo']
      if (hasUserInfo) {
        // 检查路由权限
        const userInfo = store.getters.userInfo
        if (hasPermission(userInfo, to)) {
          next()
        } else {
          // 没有权限，跳转到403页面
          next('/403')
          NProgress.done()
        }
      } else {
        try {
          // 确保获取用户信息
          if (!store.getters.roles || store.getters.roles.length === 0) {
            await store.dispatch('user/getInfo')
          }
          
          // 检查路由权限
          const userInfo = store.getters.userInfo
          if (hasPermission(userInfo, to)) {
            next()
          } else {
            // 没有权限，跳转到403页面
            next('/403')
            NProgress.done()
          }
        } catch (error) {
          await store.dispatch('user/resetToken')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router